module.exports = __webpack_public_path__ + "img/thumb_20.a62c863a.jpg";